var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.07,
    height: 24.07,
    viewBox: "0 0 24.07 24.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555",
    transform: "translate(-1396.213 -548.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox_2_",
    "data-name": "checkbox (2)",
    transform: "translate(1396.563 548.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26025",
    "data-name": "Path 26025",
    d: "M18.5,0H4.869A4.875,4.875,0,0,0,0,4.869V18.5A4.875,4.875,0,0,0,4.869,23.37H18.5A4.875,4.875,0,0,0,23.37,18.5V4.869A4.875,4.875,0,0,0,18.5,0Zm2.921,18.5A2.921,2.921,0,0,1,18.5,21.423H4.869A2.921,2.921,0,0,1,1.948,18.5V4.869A2.921,2.921,0,0,1,4.869,1.948H18.5a2.921,2.921,0,0,1,2.921,2.921Z",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26026",
    "data-name": "Path 26026",
    d: "M9.185,15.668,5.369,11.852a.974.974,0,0,0-1.377,0h0a.974.974,0,0,0,0,1.377l3.816,3.816a1.948,1.948,0,0,0,2.755,0l9.009-9.009a.974.974,0,0,0,0-1.377h0a.974.974,0,0,0-1.377,0Z",
    transform: "translate(-0.097 -0.167)",
    stroke: "#fff",
    strokeWidth: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.c0e63916908d703e106314a31b9d68ed.svg";
export { ForwardRef as ReactComponent };